import { JwtAxios } from '@/packaging';

export const qoo10Api = {
async GetQoo10ApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetQoo10ApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetQoo10ApiShipmet(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetQoo10ApiShipment?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetQoo10ReturnExchange(connectionId, marketAccount) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetQoo10ReturnExchange?connectionId=${connectionId}&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetQoo10ApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetQoo10ApiTemplate`, model);
    return responseModel;
  },
  async SetQoo10Account(connectionId, model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/SetQoo10Api?connectionId=${connectionId}`,
      model
    );
    return responseModel;
  }
};
